/* TradeTidy: keep product-card add-to-cart forms in sync with the selected colour swatch */
(function () {
  document.addEventListener("click", function (event) {
    var swatch = event.target.closest(".card-product-color-swatch");
    if (!swatch) return;
    var card = swatch.closest(".card-product") || swatch.closest("product-card");
    if (!card) return;
    var match = (swatch.getAttribute("href") || "").match(/[?&]variant=(\d+)/);
    // Bundle builder cards: swap the staged-variant blob to the chosen swatch.
    var map = card.querySelector(".tt-bundle-variant-map");
    if (map && match) {
      try {
        var data = JSON.parse(map.textContent);
        var v = data[match[1]];
        if (v) {
          var blob = card.querySelector(".custom-bundle-variant-json");
          if (blob) blob.textContent = JSON.stringify(v);
          card._variant = v;
          var bundleBtn = card.querySelector(".js-add-to-bundle");
          if (bundleBtn) {
            var avail = v.available !== false;
            bundleBtn.disabled = !avail;
            var lbl = bundleBtn.querySelector(".js-add-to-bundle-label");
            var oos = bundleBtn.querySelector(".js-add-to-bundle-oos");
            if (lbl) lbl.hidden = !avail;
            if (oos) oos.hidden = avail;
          }
        }
      } catch (e) {}
      return;
    }
    var input = card.querySelector("[data-card-variant-id]");
    if (!input) return;
    if (match) input.value = match[1];
    var button = card.querySelector("[data-card-add-to-cart]");
    if (!button) return;
    var available = swatch.dataset.variantAvailable !== "false";
    button.disabled = !available;
    var label = button.querySelector("span");
    if (label) label.textContent = available ? button.dataset.labelAdd : button.dataset.labelOut;
  });
})();
